import {Form, Formik} from 'formik';
import {useTranslation} from 'next-i18next';
import PropTypes from 'prop-types';

import TextLocal from '@/src/textLocal/containers/TextLocal';

import {Button, FileInput, Separator, Text} from '../../../ui';
import css from '../styles/ReuploadStudentIdPopupLayout.module.css';

const ReuploadStudentIdPopupLayout = ({
  onSubmitClick,
  onCancelClick,
  isLoading,
}) => {
  const {t} = useTranslation('common');

  return (
    <div className={css.popup}>
      <div className={css.heading}>
        <Text
          fontFamily={Text.FONT_FAMILY.RUBIK}
          fontSize={Text.FONT_SIZE.SIZE_32}
          fontWeight={Text.FONT_WEIGHT.MEDIUM}
        >
          <TextLocal id={'profile.upload-your-student-id'} />
        </Text>
      </div>
      <Formik
        initialValues={{
          student_identificator_file: '',
        }}
        onSubmit={onSubmitClick}
      >
        <Form>
          <>
            <div className={css.formContent}>
              <FileInput
                placeholder={t('profile.upload-id-file')}
                name={'student_identificator_file'}
                allowedFileTypes={'.pdf,image/jpeg,image/png'}
              />
            </div>
            <Separator borderWeight={Separator.BORDER_WEIGHT.THIN} />
            <div className={css.buttonsBlock}>
              <div className={css.cancelPseudoButton} onClick={onCancelClick}>
                <Text
                  fontSize={Text.FONT_SIZE.SIZE_16}
                  color={Text.COLOR.GREY}
                  fontWeight={Text.FONT_WEIGHT.BOLD}
                >
                  <TextLocal id={'create-course.cancel'} />
                </Text>
              </div>
              <Button
                type={Button.TYPES.SUBMIT}
                height={Button.HEIGHT.SMALL}
                color={Button.COLOR.PRIMARY}
                isLoading={isLoading}
              >
                <TextLocal id={'general.save'} />
              </Button>
            </div>
          </>
        </Form>
      </Formik>
    </div>
  );
};

ReuploadStudentIdPopupLayout.propTypes = {
  onSubmitClick: PropTypes.func.isRequired,
  onCancelClick: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired,
};

export default ReuploadStudentIdPopupLayout;
